import React from "react";

// Velocímetro del Hero — reproduce el gauge del Mockup Oficial (números 0..130 + km/h, aguja roja).
export default function Gauge({ size = 210 }) {
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 10;

  const values = [0, 20, 40, 60, 80, 100, 120, 130, 130];
  const start = 150;
  const end = 390;
  const step = (end - start) / (values.length - 1);

  const pol = (ang, rad) => {
    const a = (ang * Math.PI) / 180;
    return [cx + Math.cos(a) * rad, cy + Math.sin(a) * rad];
  };

  const arc = (aStart, aEnd, rr) => {
    const [x1, y1] = pol(aStart, rr);
    const [x2, y2] = pol(aEnd, rr);
    const large = aEnd - aStart > 180 ? 1 : 0;
    return `M ${x1} ${y1} A ${rr} ${rr} 0 ${large} 1 ${x2} ${y2}`;
  };

  const needleAng = 330; // apunta a ~120 km/h (arriba-derecha)
  const [nx, ny] = pol(needleAng, r - 40);

  return (
    <svg className="gauge" width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
      <circle cx={cx} cy={cy} r={r + 4} fill="rgba(13,13,13,0.45)" />
      {/* base ring */}
      <path d={arc(start, end, r)} fill="none" stroke="#3a1a05" strokeWidth="9" strokeLinecap="round" />
      {/* colored ring */}
      <path d={arc(start, 330, r)} fill="none" stroke="#E85D04" strokeWidth="9" strokeLinecap="round" />
      <path d={arc(330, end, r)} fill="none" stroke="#FF8500" strokeWidth="9" strokeLinecap="round" />

      {values.map((v, i) => {
        const ang = start + i * step;
        const [tx1, ty1] = pol(ang, r - 6);
        const [tx2, ty2] = pol(ang, r - 16);
        const [lx, ly] = pol(ang, r - 30);
        return (
          <g key={i}>
            <line x1={tx1} y1={ty1} x2={tx2} y2={ty2} stroke="#FF8500" strokeWidth="2.4" opacity="0.9" />
            <text x={lx} y={ly + size * 0.022} textAnchor="middle" fill="#ffffff" fontSize={size * 0.062}
              fontFamily="Inter" fontWeight="600">{v}</text>
          </g>
        );
      })}

      {/* needle */}
      <line x1={cx} y1={cy} x2={nx} y2={ny} stroke="#ff2d1a" strokeWidth="3.6" strokeLinecap="round" />
      <circle cx={cx} cy={cy} r={size * 0.045} fill="#F2B705" stroke="#0D0D0D" strokeWidth="2" />

      <text x={cx} y={cy + r * 0.62} textAnchor="middle" fill="#ffffff" fontSize={size * 0.055}
        fontFamily="Inter" fontWeight="500">km/h</text>
    </svg>
  );
}
